import { useState } from "react"
// import RenderField from "./RenderField"
import RenderFieldPreview from "./RenderFieldPreview"
import RenderFieldPreviewWidget from "./Encounter Widgets/RenderFieldPreview"; // just to add it as unique component imported as RenderFieldWidget
// import EncounterWidgetsPreview from "./Encounter Widgets/EncounterWidgetsPreview"
// import RenderFieldPreview from "../../../../../../../../EHR/Intake Form/RenderFieldPreview"


const CustomTemplateFormPreview = (props) => {
    const { CustomTemplateData } = props
    const data = CustomTemplateData?.Data;
    // console.log("customTemplateData123formData", CustomTemplateData)

    let count = 0;
    const excludedNames = ["Heading", "TextField", "Divider"];
    let isOpenedFromSelectedModal = props?.widgetsPreviewData?.isOpenedFromSelectedModal === "true"; // to remove Quality of Care from Select Modal
    const excludedItemsPrefixes = [
        'QualityOfCare',
        // 'ProcedureCodes',
    ];
    let updatedItems = isOpenedFromSelectedModal
        ? data?.[0]?.items?.filter(item =>
            item?.IsWidget !== "true" || !excludedItemsPrefixes.includes(item?.ItemID?.split('-')[0])
        ) : data?.[0]?.items;
    // console.log("updatedItems isOpenedFromSelectedModal", isOpenedFromSelectedModal, updatedItems)
    return (<>
        <p class="text fs-14 font-b validate-color blue-bg">{CustomTemplateData?.TemplateName || 'CUSTOM TEMPLATE'}</p>
        {updatedItems && updatedItems?.length > 0 ?
            <div className="Form-import-edit-view d-flex flex-column gap-30">
                <div className="ar_pat-info-form-fill h-auto">
                    <div className="ar_fill-content-box p-0 w-auto">
                        <div className="ar-intake-form-fill ar_star-form-Preview">
                            <div className="Form-content d-flex flex-column gap-2 h-100 p-0 overflow-visible">
                                {updatedItems.map(it => {
                                    const shouldCount = !excludedNames.some(name => it?.ItemID?.includes(name));
                                    const itemCount = shouldCount ? ++count : null;
                                    if (it?.IsWidget === "true") {
                                        const isItemProcedureCodes = (it?.ItemID?.startsWith('ProcedureCodes'));
                                        const isItemAdditionalInfo= (it?.ItemID?.startsWith('AdditionalInfo'));
                                        return <RenderFieldPreviewWidget 
                                            item={it}
                                            widgetsPreviewData={props?.widgetsPreviewData} 
                                            procedureCodesWidgetPreviewProps={isItemProcedureCodes ? props?.procedureCodesWidgetPreviewProps : {}}
                                            additionalInfoWidgetPreviewProps={isItemAdditionalInfo ? props?.additionalInfoWidgetPreviewProps : {}}
                                            itemCount={itemCount}/>
                                    }
                                    return <RenderFieldPreview item={it} activeAccordion={data?.[0]?.key || 'Intake Form'} patientName={'PatientName'}  itemCount={itemCount}/>
                                })}

                                {/* {updatedWidgetsData?.length > 0 ? 
                                <EncounterWidgetsPreview 
                                    data = {updatedWidgetsData}
                                    widgetsPreviewData={props?.widgetsPreviewData}
                                    procedureCodesWidgetPreviewProps={props?.procedureCodesWidgetPreviewProps}
                                /> : <></>}
                                {data[0]['items'].map(it => {
                                    const shouldCount = !excludedNames.some(name => it?.ItemID?.includes(name));
                                    const itemCount = shouldCount ? ++count : null;

                                    return <RenderFieldPreview item={it} activeAccordion={data?.[0]?.key || 'Intake Form'} patientName={'PatientName'}  itemCount={itemCount}
                                    // patientName={formData?.PatientName} 
/>
                                })} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div> : <p className="text ar-light-color">No data recorded</p>}</>)
}

export default CustomTemplateFormPreview